import { createContext } from 'react';

/**
 * Defines the contents of the FocusContext.
 * @internal
 */
export type FocusContextProps = {
  backgroundInertness?: boolean;
  setBackgroundInertness: (value: boolean) => void;
  focusTriggerElement: (value: HTMLElement | undefined) => void;
};

/**
 * This context keeps all information needed for proper focus management.
 * @param backgroundInertness - if the background (behind overlays) is currently inert (inactive)
 * @param setBackgroundInertness - updates the backgrounds active status
 * @internal
 */
export const FocusContext = createContext<FocusContextProps>({
  backgroundInertness: undefined,
  setBackgroundInertness: (value) => null,
  focusTriggerElement: (value) => null,
});
